<div class="main-success-div">
    <div class="success-gif-div">
        <img src="../../../assets/images/sucess-gif.gif" alt="" loop="false">
    </div>
    <div class="success-text-div">
        RECIPE ADDED
    </div>
    <div class="success-btn-div">
        <button (click)="goToDashboard()">Go to dashboard</button>
    </div>
</div>
<style>
    .main-success-div {
        text-align: center;
    }

    .success-gif-div img {
        min-width: 55px;
    }

    .success-text-div {
        font-size: 18px;
        color: green;
        margin: 25px 0px;
        font-weight: 500;
    }

    .success-btn-div button {
        background: linear-gradient(90.17deg, #2FB9E3 -97.61%, #56AB51 120.65%);
        border-radius: 6px;
        border: none;
        padding: 10px 90px;
        font-style: normal;
        font-weight: 700;
        font-size: 18px;
        color: #FFFFFF;
    }
</style>